<template>
  <header class="app-header" :class="[
      {'app-header--active': showMobileMenu},
      `app-header--${headerTheme}`
    ]">
    <!-- Logo部分（PC和Mobile共用） -->
    <h1 class="app-header__logo" @click="goToHome">
      <img :src="domainConfig?.['siteIcon']" class="app-header__logo-icon"
        :alt="domainConfig?.['siteName']">
      <div class="app-header__logo-text">
        {{domainConfig?.['siteName']}}
      </div>
    </h1>

    <!-- PC导航菜单 (只在桌面设备显示) -->
    <nav class="app-header__nav" v-if="deviceType === 'desktop' || deviceType === 'pc'">
      <div class="app-header__nav-item"
        :class="{'app-header__nav-item--active': isRouteActive('/')}" @click="goToHome">
        <img
          :src="isRouteActive('/') ? require('@/assets/default/home-icon-active.svg') : require('@/assets/default/home-icon.svg')"
          class="app-header__nav-icon" alt="">
        <span>Home</span>
      </div>
      <!-- <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/all') || isTrendsActive}"
        @click="toggleDropdown('trends')" ref="trendsNavItem">
        <img
          :src="isRouteActive('/all') || isTrendsActive ? require('@/assets/default/trends-icon-active.svg') : require('@/assets/default/trends-icon.svg')"
          class="app-header__nav-icon" alt="">
        <span>Trends</span>
        <img src="@/assets/default/arrow-down.svg" class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': activeDropdown === 'trends'}" alt="">

        <div class="app-header__dropdown" v-if="activeDropdown === 'trends'" ref="trendsDropdown">
          <Menus :menuItems="trendsMenuItems" @item-click="handleTrendsItemClick" />
        </div>
      </div> -->
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/movies') || isMoviesActive}"
        @click="toggleDropdown('movies')" ref="moviesNavItem">
        <img
          :src="isRouteActive('/movies') || isMoviesActive ? require('@/assets/default/movies-icon-active.svg') : require('@/assets/default/movies-icon.svg')"
          class="app-header__nav-icon" alt="">
        <span>Movies</span>
        <img src="@/assets/default/arrow-down.svg" class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': activeDropdown === 'movies'}" alt="">

        <!-- Movies下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--movies"
          v-if="activeDropdown === 'movies'" ref="moviesDropdown">
          <Menus :menuItems="formattedMovieGenres" @item-click="handleMoviesItemClick" />
        </div>
      </div>
      <div class="app-header__nav-item app-header__nav-item--has-dropdown"
        :class="{'app-header__nav-item--active': isRouteActive('/tv-shows') || isTVShowsActive}"
        @click="toggleDropdown('tv-shows')" ref="tvshowsNavItem">
        <img
          :src="isRouteActive('/tv-shows') || isTVShowsActive ? require('@/assets/default/tv-icon-active.svg') : require('@/assets/default/tv-icon.svg')"
          class="app-header__nav-icon" alt="">
        <span>TV Shows</span>
        <img src="@/assets/default/arrow-down.svg" class="app-header__nav-arrow"
          :class="{'app-header__nav-arrow--flip': activeDropdown === 'tv-shows'}" alt="">

        <!-- TV Shows下拉菜单 -->
        <div class="app-header__dropdown app-header__dropdown--tv-shows"
          v-if="activeDropdown === 'tv-shows'" ref="tvshowsDropdown">
          <Menus :menuItems="formattedTvGenres" @item-click="handleTVShowsItemClick" />
        </div>
      </div>
      <div class="app-header__download-btn" @click="navigateToPage('/movie-download/')">
        <img src="@/assets/default/download-icon.svg" class="app-header__download-icon" alt="">
        <span>Download</span>
      </div>
    </nav>

    <!-- Mobile菜单按钮 (只在移动设备显示) -->
    <div class="app-header__mobile-trigger" v-if="deviceType === 'mobile'"
      @click="toggleMobileMenu">
      <img :class="{'close': showMobileMenu}"
        :src="showMobileMenu ? require('@/assets/default/menu-icon-close.svg') : require('@/assets/default/menu-icon.svg')"
        alt="">
    </div>

    <!-- Mobile菜单 (显示/隐藏取决于showMobileMenu) -->
    <div class="app-header__mobile-menu-row" v-if="showMobileMenu && deviceType === 'mobile'">
      <div class="app-header__mobile-menu">
        <div class="app-header__mobile-menu-tabs">
          <!-- <div class="app-header__mobile-menu-tab"
            :class="{'app-header__mobile-menu-tab--active': activeMobileTab === 'trends'}"
            @click="activeMobileTab = 'trends'">
            <img
              :src="activeMobileTab === 'trends' ? require('@/assets/default/trends-icon-active.svg') : require('@/assets/default/trends-icon.svg')"
              alt="">
            <span>Trends</span>
          </div> -->
          <div class="app-header__mobile-menu-tab"
            :class="{'app-header__mobile-menu-tab--active': activeMobileTab === 'movies'}"
            @click="activeMobileTab = 'movies'">
            <img
              :src="activeMobileTab === 'movies' ? require('@/assets/default/movies-icon-active.svg') : require('@/assets/default/movies-icon.svg')"
              alt="">
            <span>Movies</span>
          </div>
          <div class="app-header__mobile-menu-tab"
            :class="{'app-header__mobile-menu-tab--active': activeMobileTab === 'tv-shows'}"
            @click="activeMobileTab = 'tv-shows'">
            <img
              :src="activeMobileTab === 'tv-shows' ? require('@/assets/default/tv-icon-active.svg') : require('@/assets/default/tv-icon.svg')"
              alt="">
            <span>TV Shows</span>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <div class="app-header__mobile-menu-categories">
          <div class="app-header__mobile-menu-categories-grid">
            <template v-if="activeMobileTab === 'trends'">
              <div class="app-header__mobile-menu-category" v-for="item in trendsMenuItems"
                :key="item.value" @click="handleTrendsItemClick(item.value)">
                {{ item.label }}
              </div>
            </template>
            <template v-if="activeMobileTab === 'movies'">
              <div class="app-header__mobile-menu-category" v-for="item in formattedMovieGenres"
                :key="item.value" @click="handleMoviesItemClick(item.value)">
                {{ item.label }}
              </div>
            </template>
            <template v-if="activeMobileTab === 'tv-shows'">
              <div class="app-header__mobile-menu-category" v-for="item in formattedTvGenres"
                :key="item.value" @click="handleTVShowsItemClick(item.value)">
                {{ item.label }}
              </div>
            </template>
          </div>
        </div>

        <div class="app-header__mobile-menu-divider"></div>

        <div class="app-header__mobile-menu-links">
          <div class="app-header__mobile-menu-link" @click="goToHome">
            <img src="@/assets/default/home-icon.svg" alt="">
            <span>Home</span>
            <img src="@/assets/default/arrow-right.svg" class="app-header__mobile-menu-link-arrow"
              alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="$router.push('/about-us')">
            <img src="@/assets/default/about-icon.svg" alt="">
            <span>About us</span>
            <img src="@/assets/default/arrow-right.svg" class="app-header__mobile-menu-link-arrow"
              alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="$router.push('/terms-of-service')">
            <img src="@/assets/default/terms-icon.svg" alt="">
            <span>Terms of Services</span>
            <img src="@/assets/default/arrow-right.svg" class="app-header__mobile-menu-link-arrow"
              alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="$router.push('/privacy-policy')">
            <img src="@/assets/default/privacy-icon.svg" alt="">
            <span>Privacy Policy</span>
            <img src="@/assets/default/arrow-right.svg" class="app-header__mobile-menu-link-arrow"
              alt="">
          </div>
          <div class="app-header__mobile-menu-link" @click="$router.push('/disclaimer')">
            <img src="@/assets/default/disclaimer-icon.svg" alt="">
            <span>Disclaimer</span>
            <img src="@/assets/default/arrow-right.svg" class="app-header__mobile-menu-link-arrow"
              alt="">
          </div>
        </div>
      </div>

    </div>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import Menus from '@/components/Menu.vue';

export default {
  name: 'AppHeader',
  components: {
    Menus
  },
  props: {
    headerTheme: {
      type: String,
      default: 'light' // 可选值：'light'或'dark'
    },
  },
  computed: {
    ...mapGetters({
      deviceType: 'deviceType',
      domainConfig: 'domainConfig',
      categories: 'categories',
      categoriesLoaded: 'categoriesLoaded',
      tvGenres: 'tvGenres',
      movieGenres: 'MovieGenres'
    }),
    isTrendsActive () {
      return this.$route.path.includes('/trends/');
    },
    isMoviesActive () {
      return this.$route.path.includes('/movies/');
    },
    isTVShowsActive () {
      return this.$route.path.includes('/tv-shows/');
    },
    formattedTvGenres () {
      // 将tvGenres格式化为下拉菜单需要的格式
      return this.tvGenres.map(genre => ({
        label: genre.name,
        value: genre.id.toString()
      }));
    },
    formattedMovieGenres () {
      // 将movieGenres格式化为下拉菜单需要的格式
      if (!this.movieGenres || this.movieGenres.length === 0) {
        // 如果还没有获取到电影类型，返回默认值
        return this.moviesMenuItems;
      }
      return this.movieGenres.map(genre => ({
        label: genre.name,
        value: this.formatGenreName(genre.name),
        id: genre.id.toString()
      }));
    }
  },
  data () {
    return {
      showMobileMenu: false,
      activeDropdown: null,
      activeMobileTab: 'movies',
      navItems: [
        { name: 'Home', link: '/' },
        { name: 'Categories', link: '/all' },
        { name: 'Rankings', link: '/rank' },
        { name: 'About us', link: '/about-us' },
      ],
      trendsMenuItems: [
        { label: 'Popular Movies', value: 'popular-movies' },
        { label: 'Now Playing Movies', value: 'now-playing-movies' },
        { label: 'Top Rated Movies', value: 'top-rated-movies' },
        { label: 'Popular TV Shows', value: 'popular-tv-shows' },
        { label: 'Top Rated TV Shows', value: 'top-rated-tv-shows' },
        { label: 'Now Playing TV Shows', value: 'now-playing-tv-shows' }
      ],
      moviesMenuItems: [
        { label: 'Action', value: 'action', id: '28' },
        { label: 'Adventure', value: 'adventure', id: '12' },
        { label: 'Animation', value: 'animation', id: '16' },
        { label: 'Comedy', value: 'comedy', id: '35' },
        { label: 'Crime', value: 'crime', id: '80' },
        { label: 'Documentary', value: 'documentary', id: '99' },
        { label: 'Drama', value: 'drama', id: '18' },
        { label: 'Family', value: 'family', id: '10751' },
        { label: 'Fantasy', value: 'fantasy', id: '14' },
        { label: 'History', value: 'history', id: '36' },
        { label: 'Horror', value: 'horror', id: '27' },
        { label: 'Music', value: 'music', id: '10402' },
        { label: 'Mystery', value: 'mystery', id: '9648' },
        { label: 'Romance', value: 'romance', id: '10749' },
        { label: 'Science Fiction', value: 'science-fiction', id: '878' },
        { label: 'TV Movie', value: 'tv-movie', id: '10770' },
        { label: 'Thriller', value: 'thriller', id: '53' },
        { label: 'War', value: 'war', id: '10752' },
        { label: 'Western', value: 'western', id: '37' }
      ],
    };
  },
  methods: {
    toggleMobileMenu () {
      this.showMobileMenu = !this.showMobileMenu;

      // 如果打开菜单，禁止body滚动
      if (this.showMobileMenu) {
        document.body.style.overflow = 'hidden';
        document.body.style.height = '100%';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
      } else {
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }
    },

    toggleDropdown (type) {
      if (this.activeDropdown === type) {
        this.activeDropdown = null;
      } else {
        this.activeDropdown = type;
      }
    },

    // 判断当前路由是否激活
    isRouteActive (link) {
      // 获取不包含channel参数的当前路径
      let currentPath = this.$route.path;
      const channel = this.$route.params.channel;

      // 如果存在channel参数，移除channel部分以便正确比较
      if (channel && currentPath.startsWith(`/${channel}`)) {
        currentPath = currentPath.replace(`/${channel}`, '') || '/';
      }

      // 处理根路径特殊情况
      if (link === '/' && (currentPath === '/' || currentPath === '')) {
        return true;
      }

      // 处理首页特殊情况
      if (link === '/' && currentPath !== '/') {
        return false;
      }

      // 处理子路径，如果当前路径以链接开头，则认为该链接处于激活状态
      if (link !== '/' && currentPath.startsWith(link)) {
        return true;
      }

      // Categories页面特殊处理
      if (link === '/categories') {
        // 如果路径是/categories或者是带有特定类别的路径（如/biography, /romance等）
        if (currentPath === '/categories') {
          return true;
        }

        // 检查是否是类别页面
        const categoryValues = this.categories.map(c => `/${c.value}`);
        if (categoryValues.includes(currentPath)) {
          return true;
        }

        return false;
      }

      // 其他页面直接比较路径
      return currentPath === link;
    },

    goToHome () {
      if (this.$route.path !== '/') {
        // 检查是否存在channel参数
        if (this.$route.params.channel) {
          // 如果有channel参数，使用完整路径
          window.location.href = `/${this.$route.params.channel}`;
        } else {
          // 保留查询参数
          this.$router.push({
            path: '/',
          });
        }
      }
    },

    // 获取导航链接
    getNavLink (link) {
      // 获取当前URL的查询参数
      const currentQuery = this.$route.query;
      const queryString = Object.keys(currentQuery).length > 0
        ? `?${new URLSearchParams(currentQuery).toString()}`
        : '';

      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果是首页链接
        if (link === '/') {
          return `/${this.$route.params.channel}/${queryString}`;
        }
        // 其他链接
        return `/${this.$route.params.channel}${link}${queryString}`;
      }
      return `${link}${queryString}`;
    },

    // 处理Trends菜单项点击
    handleTrendsItemClick (value) {
      console.log('Trends item clicked:', value);
      this.activeDropdown = null;
      // 导航到相应页面
      this.navigateToPage(`/trends/${value}`);
    },

    // 处理Movies菜单项点击
    handleMoviesItemClick (value) {
      console.log('Movies item clicked:', value);
      this.activeDropdown = null;

      // 找到对应的电影类型
      const selectedGenre = this.formattedMovieGenres.find(item => item.value === value);

      if (selectedGenre) {
        // 在导航前不要重置 selectedYear 和 selectedStream，保持当前选择状态
        // 导航到相应页面，使用genre名称和ID作为参数
        this.navigateToPage(`/movies/${selectedGenre.value}/${selectedGenre.id}/`);
      } else {
        // 如果没有找到对应的genre，则导航到movies主页
        this.navigateToPage('/movies');
      }
    },

    // 处理TV Shows菜单项点击
    handleTVShowsItemClick (value) {
      console.log('TV Shows item clicked:', value);
      this.activeDropdown = null;
      // 使用genre ID作为路由参数
      // 从formattedTvGenres中找到对应的genre对象
      const selectedGenre = this.formattedTvGenres.find(item => item.value === value);

      if (selectedGenre) {
        // 在导航前不要重置 selectedYear，保持当前选择状态
        // 获取genre的名称，并格式化为URL友好的格式
        const genreName = this.formatGenreName(selectedGenre.label);
        // 导航到相应页面，使用genre ID和名称作为参数
        this.navigateToPage(`/tv-shows/${genreName}/${selectedGenre.value}/`);
      } else {
        // 如果没有找到对应的genre（如点击了"all"选项），则导航到tvshows主页
        this.navigateToPage('/tv-shows/');
      }
    },

    // 通用导航方法
    navigateToPage (path) {
      console.log(path);
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}${path}`);
      } else {
        // 如果没有channel参数，直接导航
        this.$router.push(path);
      }
    },

    // 导航到特定类别页面 (保留原方法供兼容)
    goToCategory (category) {
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，使用完整路径
        this.$router.push(`/${this.$route.params.channel}/${category}`);
      } else {
        // 如果没有channel参数，直接导航到类别页面
        this.$router.push(`/${category}`);
      }
    },

    // 处理点击其他区域关闭下拉菜单
    handleClickOutside (event) {
      // 检查点击是否在下拉菜单区域外
      const isOutsideTrends = this.$refs.trendsDropdown && !this.$refs.trendsDropdown.contains(event.target);
      const isOutsideMovies = this.$refs.moviesDropdown && !this.$refs.moviesDropdown.contains(event.target);
      const isOutsideTVShows = this.$refs.tvshowsDropdown && !this.$refs.tvshowsDropdown.contains(event.target);

      // 检查点击是否在导航项目上（避免冒泡导致立即关闭）
      const isNavItem = event.target.closest('.app-header__nav-item');

      if ((isOutsideTrends && isOutsideMovies && isOutsideTVShows) && !isNavItem) {
        this.activeDropdown = null;
      }
    },

    // 获取考虑channel参数的路由路径
    getRouteWithChannel (path) {
      // 检查是否存在channel参数
      if (this.$route.params.channel) {
        // 如果有channel参数，在路径前添加channel
        return `/${this.$route.params.channel}${path}`;
      }
      // 否则返回原始路径
      return path;
    },

    formatGenreName (name) {
      return name.toLowerCase().replace(/\s+/g, '-').replace(/&/g, 'and');
    }
  },
  beforeDestroy () {
    // 确保在组件销毁时恢复body滚动
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.width = '';
    // 移除点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted () {
    // 监听路由变化，关闭移动菜单
    this.$router.afterEach(() => {
      if (this.showMobileMenu) {
        this.showMobileMenu = false;
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.position = '';
        document.body.style.width = '';
      }

      // 关闭所有下拉菜单
      this.activeDropdown = null;
    });

    // 添加点击其他区域关闭下拉菜单的事件监听
    document.addEventListener('click', this.handleClickOutside);
  }
};
</script>

<style lang="scss">
@import '~@/css/variables.scss';

.app-header {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	position: relative;
	width: 100%;
	box-sizing: border-box;
	background-color: transparent;
	z-index: 100;
	height: rem(80);

	// 主题样式
	&--light {
		color: #ffffff;
	}

	&--dark {
		color: #000000;
	}

	// Logo部分样式
	&__logo {
		background: #0d0c0f;
		border-radius: rem(8);
		padding: rem(8) rem(16) rem(8) rem(12);
		display: flex;
		flex-direction: row;
		gap: rem(12);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;
		cursor: pointer;

		&-icon {
			flex-shrink: 0;
			width: rem(28);
			height: rem(28);
			position: relative;
			overflow: visible;
		}

		&-text {
			color: #ffffff;
			text-align: left;
			font-size: rem(20);
			line-height: rem(20);
			font-weight: 700;
			text-transform: uppercase;
			position: relative;
		}
	}

	// PC导航菜单样式
	&__nav {
		display: flex;
		flex-direction: row;
		gap: rem(52);
		align-items: center;
		justify-content: flex-start;
		flex-shrink: 0;
		position: relative;

		&-item {
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: flex-start;
			flex-shrink: 0;
			position: relative;
			cursor: pointer;

			span {
				color: #ffffff;
				text-align: left;
				font-family: 'Inter-Regular', sans-serif;
				font-size: rem(16);
				line-height: rem(16);
				font-weight: 400;
				position: relative;
			}

			&--active span {
				font-family: 'Inter-Bold', sans-serif;
				font-weight: 700;
			}

			&--has-dropdown {
				position: relative;
			}
		}

		&-icon {
			flex-shrink: 0;
			width: rem(20);
			height: rem(20);
			position: relative;
			overflow: visible;
		}

		&-arrow {
			flex-shrink: 0;
			width: rem(8);
			height: rem(4);
			position: relative;
			overflow: visible;
			aspect-ratio: 2/1;

			&--flip {
				transform: rotate(180deg);
			}
		}
	}

	// 下载按钮样式
	&__download-btn {
		background: #fe324b;
		border-radius: rem(100);
		padding: rem(8) rem(16);
		display: flex;
		flex-direction: row;
		gap: rem(8);
		align-items: center;
		justify-content: center;
		flex-shrink: 0;
		position: relative;
		cursor: pointer;

		span {
			color: #ffffff;
			text-align: left;
			font-family: 'Inter', sans-serif;
			font-size: rem(16);
			line-height: rem(16);
			font-weight: 400;
			position: relative;
		}

		&-icon {
			flex-shrink: 0;
			width: rem(20);
			height: rem(20);
			position: relative;
			overflow: visible;
		}
	}

	// 下拉菜单样式
	&__dropdown {
		position: absolute;
		top: 100%;
		left: 50%;
		transform: translateX(-50%);
		z-index: 1000;
		margin-top: rem(8);
	}

	// Mobile菜单按钮样式
	&__mobile-trigger {
		flex-shrink: 0;
		width: rem(28);
		height: rem(28);
		position: relative;
		overflow: visible;
		cursor: pointer;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: rem(28);
			height: rem(28);
		}

		.close {
			width: rem(16);
			height: rem(16);
		}
	}

	// Mobile菜单样式
	&__mobile-menu-row {
		position: fixed;
		top: rem(76); // 头部高度加上padding
		height: calc(100vh - rem(76));
		left: 0;
		width: 100%;
		background: rgba(0, 0, 0, 0.5);
	}
	&__mobile-menu {
		width: 100%;
		background: linear-gradient(180deg, rgba(13, 12, 15, 1) 0%, rgba(42, 40, 46, 1) 100%);
		border-radius: 0 0 rem(16) rem(16);
		padding: rem(16) 0;
		display: flex;
		flex-direction: column;
		gap: rem(16);
		z-index: 999;

		&-tabs {
			display: flex;
			flex-direction: row;
			width: 100%;
		}

		&-tab {
			flex: 1;
			padding: rem(12) 0 rem(16);
			display: flex;
			flex-direction: row;
			gap: rem(8);
			align-items: center;
			justify-content: center;
			cursor: pointer;

			img {
				width: rem(20);
				height: rem(20);
			}

			span {
				color: #ffffff;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 400;
			}

			&--active {
				border-bottom: rem(2) solid #fe324b;

				span {
					font-weight: 700;
				}
			}
		}

		&-divider {
			background: #ffffff;
			opacity: 0.04;
			height: rem(1);
			width: 100%;
		}

		&-categories {
			padding: 0 rem(16);
			max-height: rem(240);
			overflow: hidden;

			&-grid {
				display: grid;
				grid-template-columns: repeat(2, 1fr);
				gap: rem(8);
			}
		}

		&-category {
			background: rgba(255, 255, 255, 0.08);
			border-radius: rem(8);
			padding: rem(12) rem(16);
			color: #ffffff;
			font-size: rem(13);
			line-height: rem(14);
			cursor: pointer;
		}

		&-links {
			padding: 0 rem(16);
			display: flex;
			flex-direction: column;
			gap: rem(8);
		}

		&-link {
			border-radius: rem(8);
			padding: rem(14) 0;
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: space-between;
			height: rem(36);
			position: relative;
			cursor: pointer;

			img {
				width: rem(20);
				height: rem(20);
			}

			span {
				color: #ffffff;
				font-size: rem(14);
				line-height: rem(14);
				font-weight: 400;
				margin-left: rem(8);
				flex-grow: 1;
			}

			&-arrow {
				width: rem(4);
				height: rem(8);
			}
		}
	}

	&--active {
		// 当移动菜单展开时的样式
	}
}

// PC端基础样式
.detect_deviece_pc,
.detect_deviece_desktop {
	.app-header {
		padding: rem(16) rem(80);

		&__nav-item {
			&--has-dropdown {
				.app-header__dropdown {
					left: 0;
					transform: translateX(0);
					min-width: rem(200);
				}
			}
		}
	}
}

// 移动端基础样式
.detect_deviece_mobile {
	.app-header {
		padding: rem(16);

		&--active {
			background: #000 !important;
		}

		&__logo-text {
			font-size: rem(18);
			line-height: rem(18);
			font-weight: 900;
			text-transform: uppercase;
			position: relative;
			overflow: hidden;
			display: -webkit-box;
			text-overflow: ellipsis;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;

			&--active {
				color: #050b20 !important;
			}
		}

		&__mobile-menu {
			&-categories {
				padding: 0 rem(16);
				max-height: rem(240);
				overflow-y: auto;
				scrollbar-width: thin;
				scrollbar-color: rgba(254, 50, 75, 0.5) rgba(255, 255, 255, 0.05);

				/* 自定义滚动条样式 */
				&::-webkit-scrollbar {
					width: rem(4);
				}

				&::-webkit-scrollbar-track {
					background: rgba(255, 255, 255, 0.05);
					border-radius: rem(4);
				}

				&::-webkit-scrollbar-thumb {
					background-color: rgba(254, 50, 75, 0.5);
					border-radius: rem(4);
				}

				&-grid {
					display: grid;
					grid-template-columns: repeat(2, 1fr);
					gap: rem(8);
					padding-right: rem(4);
					padding-bottom: rem(8);
				}
			}

			&-category {
				background: rgba(255, 255, 255, 0.08);
				border-radius: rem(8);
				padding: rem(12) rem(16);
				color: #ffffff;
				font-size: rem(13);
				line-height: rem(14);
				cursor: pointer;
				transition: background 0.3s ease;

				&:active {
					background: rgba(254, 50, 75, 0.2);
				}
			}
		}
	}
}
</style>
